import { GeneralStyle } from '@website-builder/model/style/general-style';

export class ListStyle extends GeneralStyle {
  listStyle = '';
  padding = '';
  textStyle = '';
  displayAsLink = false;
  linkStyle = '';
  iconSize = '';
  iconColor = '';

  static normalize(listStyles: Partial<ListStyle>): ListStyle {
    const generalStyle: GeneralStyle = GeneralStyle.normalize(listStyles);
    const pureListStyle = new ListStyle();

    Object.assign(pureListStyle, generalStyle);

    pureListStyle.listStyle = listStyles.listStyle ?? pureListStyle.listStyle;
    pureListStyle.padding = listStyles.padding ?? pureListStyle.padding;
    pureListStyle.textStyle = listStyles.textStyle ?? pureListStyle.textStyle;
    pureListStyle.displayAsLink = listStyles.displayAsLink ?? pureListStyle.displayAsLink;
    pureListStyle.linkStyle = listStyles.linkStyle ?? pureListStyle.linkStyle;
    pureListStyle.iconSize = listStyles.iconSize ?? pureListStyle.iconSize;
    pureListStyle.iconColor = listStyles.iconColor ?? pureListStyle.iconColor;

    return pureListStyle;
  }
}
